module.exports = __webpack_public_path__ + "assets/img/solar-panels-3-small.fe6a73fb.jpg";